import UserDialog98 from '@/generated/controls/user/UserDialog98.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: UserDialog98
})
